module.exports = __webpack_public_path__ + "aa748fc5519cb4a08b9d3cec5bba77ca.svg";